(function (angular) {
  'use strict';

  angular.module('myApp').config([
    '$stateProvider',
    function ($stateProvider) {

      $stateProvider.state('optionGroups', {
          url: '/admin/option-groups',
          component: 'optionGroups',
          data: {
            permissions: ['optionGroups']
          }
        })
        .state('optionGroupsCreate', {
          url: '/admin/option-groups/create',
          component: 'optionGroupsCreate',
          data: {
            permissions: ['optionGroups.create']
          }
        })
        //.state('optionGroupsEdit', {
        //  parent: 'catalog',
        //  url: '/admin/option-groups/edit/{id:int}',
        //  component: 'optionGroupsEdit',
        //  data: {
        //    permissions: ['optionGroups.edit']
        //  }
        //});
        .state('optionGroupsEdit', {
          url: '/admin/option-group/edit/{id:int}',
          redirectTo: 'optionGroupInformationEdit',
          component: 'optionGroupsEdit',
          data: {
            permissions: ['optionGroups.edit']
          }
        })
        .state('optionGroupInformationEdit',
          {
            parent: 'optionGroupsEdit',
            url: '/info',
            component: 'optionGroupInformationEdit',
            data: {
              permissions: ['optionGroups.edit']
            }
          });


      $stateProvider.state('options',
        {
          parent: 'optionGroupsEdit',
          url: '/option',
          redirectTo: 'optionsList',
          template: '<ui-view></ui-view>',
          data: { permissions: ['options'] }
        })
        .state('optionsList',
          {
            parent: 'options',
            component: 'optionsList',
            data: { permissions: ['options'] }
          })
        .state('optionCreate', {
          parent: 'options',
          url: '/create',
          component: 'optionCreate',
          data: {
            permissions: ['options']
          }
        })
        .state('optionEdit', {
          parent: 'options',
          url: '/edit/{childId:int}',
          component: 'optionEdit',
          data: {
            permissions: ['options']
          }
        });
    }
  ]);

})(angular);
